import React, { Component } from 'react';
import GatsbyLink from '../../GatsbyLink'
import { navigate } from 'gatsby'
import './PostListNavigation.scss'

const isClient = typeof window !== 'undefined';

class PostListNavigationPass extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mobileMenu: isClient && window.innerWidth > 1080 ? false : true,
    }
  }


  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    if (isClient && window.innerWidth > 1080) {
      this.setState({mobileMenu: false})
    } else {
      this.setState({mobileMenu: true})
    }
  }

  handleChange(e, isRoot) {
    const path = e.target.value
    if (path) {
      if (!path) return null;
      navigate(
        path,
        {
          state: {
            // We don't want our scroll update to be ignored on the root category
            disableScrollUpdate: isRoot ? false : true,
          },
        }
      )
      this.setState({mobileMenu: true})
    }
  }

  handleClick(path, isRoot) {
    if (!path) return null;
    navigate(
      path,
      {
        state: {
          // We don't want our scroll update to be ignored on the root category
          disableScrollUpdate: isRoot ? false : true,
        },
      }
    )
  }

  render() {
    const { pathPrefix, categoryFilter, postSlug, categories } = this.props;
    if (this.state.mobileMenu) {
      return (
        <div className="post-list-navigation">
          <div className="inner">
            <select onChange={event => this.handleChange(event)} value={pathPrefix}>
              <option value={postSlug}>Filter By</option>
              {categories && categories.map((category , index) => category.slug !== 'uncategorised' && (
                <option value={category.path} key={index}>{category.name}</option>
              ))}
            </select>
          </div>
        </div>
      )
    } else {
      return (
        <div className="post-list-navigation">
          <div className="inner">
            <strong>Filter by: </strong>
            <ul>
              {categories && categories.map((category , index) => category.slug !== 'uncategorised' && (
                <li key={index} onClick={event => this.handleClick(category.path)}><GatsbyLink to={category.path} activeClassName="active" dangerouslySetInnerHTML={{ __html: category.name }}/></li>
              ))}
            </ul>
          </div>
        </div>
      )
    }


  }
}

export const PostListNavigation = (props) => {
  return (
    <PostListNavigationPass {...props} />
  )
}

export default PostListNavigation
